<template>
  <div>
    <a-drawer
      :zIndex="2000"
      class="view-devices-volume"
      wrapClassName="drawer"
      placement="right"
      :visible="visible"
      @close="$emit('close')"
    >
      <template #title>
        <div class="flex space-x-6 items-center">
          <p class="text-xl border-r p-4 pl-0">
            {{ $t('mygwf.components.Label.volume_reports') }}
          </p>
          <div class="flex flex-col space-y-1 p-2 rounded">
            <p class="flex space-x-3 items-center justify-between">
              <span class="text-sm"> {{ $t('mygwf.components.Label.meter') }}: </span>
              <span class="text-xs text-gray-400">{{ meter.meter_serial }} </span>
            </p>
            <p v-if="meter.comd_serial" class="flex space-x-3 items-center justify-between">
              <span class="text-sm">{{ $t('mygwf.components.Label.module') }}: </span>
              <span class="text-xs text-gray-400">{{ meter.comd_serial }}</span>
            </p>
          </div>
        </div>
      </template>
      <ReportChart :meter="meter" :volumeReport="true" />
    </a-drawer>
  </div>
</template>

<script>
import ReportChart from '@/components/pages/reports/ReportChart.vue'
import Drawer from 'ant-design-vue/lib/drawer'
import 'ant-design-vue/lib/drawer/style/index.css'

export default {
  components: {
    ReportChart,
    'a-drawer': Drawer,
  },
  props: {
    visible: {
      type: Boolean,
      required: true,
      default: false,
    },
    meter: {
      type: Object,
      required: true,
    },
  },
}
</script>
